import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import { FaCog } from "react-icons/fa";

export default function UserRolesDistribution() {
  const dataMap = {
    Today: [
      { label: "Employees", value: 2145, color: "#f2540b" },
      { label: "Managers", value: 234, color: "#2f5d62" },
      { label: "HR Operations", value: 45, color: "#2c2c2c" },
      { label: "Admins", value: 12, color: "#fbbf24" },
    ],
    Weekly: [
      { label: "Employees", value: 1800, color: "#f2540b" },
      { label: "Managers", value: 300, color: "#2f5d62" },
      { label: "HR Operations", value: 70, color: "#2c2c2c" },
      { label: "Admins", value: 25, color: "#fbbf24" },
    ],
    Monthly: [
      { label: "Employees", value: 2500, color: "#f2540b" },
      { label: "Managers", value: 400, color: "#2f5d62" },
      { label: "HR Operations", value: 120, color: "#2c2c2c" },
      { label: "Admins", value: 100, color: "#fbbf24" },
    ],
  };

  const [filter, setFilter] = useState("Today");
  const roles = dataMap[filter];

  const maxValue = Math.max(...roles.map((r) => r.value));

  return (
    <Card className="role-card">
      <Card.Body>
        {/* Header */}
        <div className="header">
          <div className="title">
             <strong className="icon-box"></strong>
          <strong>
            
            User Roles Distribution 
          </strong>
          </div>

          <div className="actions">
            <Dropdown>
              <Dropdown.Toggle className="dropdown-btn">
                <FiCalendar /> {filter}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {Object.keys(dataMap).map((key) => (
                  <Dropdown.Item key={key} onClick={() => setFilter(key)}>
                    {key}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <div className="settings">
              <FaCog />
            </div>
          </div>
        </div>

        {/* Bars */}
        <div className="roles-container">
          {roles.map((r, i) => {
            const width = (r.value / maxValue) * 100;

            return (
              <div className="role-item" key={i}>
                <div className="label">{r.label}</div>

                <div className="bar-wrapper">
                  <div
                    className="bar"
                    style={{
                      width: `${width}%`,
                      backgroundColor: r.color,
                    }}
                  >
                    <div className="tooltip">{r.value}</div>
                  </div>
                </div>

                <div className="value">{r.value}</div>
              </div>
            );
          })}
        </div>
      </Card.Body>

      {/* INTERNAL CSS */}
      <style>{`
        .role-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          flex-wrap: wrap;
          gap: 10px;
        }

        .title {
          font-weight: 500;
          font-size: 16px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .icon-box {
          width: 14px;
          height: 14px;
          border: 2px solid #ff6b1a;
          border-radius: 3px;
        }

        .actions {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .dropdown-btn {
          background: #fff !important;
          color: #333 !important;
          border: 1px solid #ddd !important;
          border-radius: 8px !important;
          padding: 6px 12px !important;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .settings {
          background: #ff6b1a;
          color: #fff;
          padding: 8px;
          border-radius: 6px;
          cursor: pointer;
        }

        .roles-container {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
        }

        .role-item {
          flex: 1;
          min-width: 200px;
        }

        .label {
          font-size: 14px;
          margin-bottom: 6px;
        }

        .value {
          margin-top: 6px;
          font-size: 14px;
          color: #555;
        }

        .bar-wrapper {
          background: #f1f1f1;
          border-radius: 6px;
          height: 16px;
          overflow: hidden;
          position: relative;
        }

        .bar {
          height: 100%;
          border-radius: 6px;
          position: relative;
          background-image: repeating-linear-gradient(
            45deg,
            rgba(255,255,255,0.2),
            rgba(255,255,255,0.2) 10px,
            transparent 10px,
            transparent 20px
          );
          transition: 0.4s;
        }

        /* Tooltip */
        .tooltip {
          position: absolute;
          top: -30px;
          right: 0;
          background: #111;
          color: #fff;
          padding: 4px 8px;
          font-size: 12px;
          border-radius: 4px;
          opacity: 0;
          transform: translateY(5px);
          transition: 0.3s;
          white-space: nowrap;
        }

        .bar:hover .tooltip {
          opacity: 1;
          transform: translateY(0);
        }
          .dropdown-toggle::after {
  display: none !important;
}

        /* Mobile */
        @media (max-width: 768px) {
          .roles-container {
            flex-direction: column;
          }
        }
      `}</style>
    </Card>
  );
}